(function () {
  'use strict';

  function init() {
    const badge = document.querySelector(
      '[id*="judge_me_reviews_preview_badge"]'
    );
    const target = document.getElementById('bewertungen-anker');

    if (!badge || !target) return;

    badge.style.cursor = 'pointer';
    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('aria-label', 'Zur Bewertungs-Section springen');

    function scrollToTarget() {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
      target.scrollIntoView({
        behavior: reduceMotion ? 'instant' : 'smooth',
        block: 'start',
      });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }

    badge.addEventListener('click', scrollToTarget);
    badge.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToTarget();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
